<template>
  <InterfaceCard
      icon='mdi-credit-card-outline'
      title='Оплата заказа'
  >
    <div>
      <v-skeleton-loader
          v-if="loading"
          type="card"
      ></v-skeleton-loader>
      <Info
          v-else-if="error"
          :error="error">
      </Info>
      <div v-else>
        <v-form
            v-model="formIsValid"
            ref="paymentForm"
        >
          <div v-if="canUseBalance">
            <v-checkbox
                v-model="toBalance.active"
                :label="labelToBalanceActivator"
                :ripple="false"
                @change="changeToBalanceActive"
            ></v-checkbox>
          </div>

          <v-text-field
              v-if="toBalance && toBalance.active"
              v-model="toBalance.amountReal"
              disabled
              prepend-icon="mdi-cash"
              :label="labelAmount"
          ></v-text-field>
          <v-text-field
              v-else
              v-model="invoice.confirmation.amount"
              disabled
              prepend-icon="mdi-cash"
              type="number"
              :label="labelAmount"
          ></v-text-field>

          <v-row
              class="mb-4"
              dense
          >
            <v-col cols="auto">
              <v-select
                  v-model="phoneCode"
                  class="phone-code"
                  label="Телефон"
                  prepend-icon="mdi-phone"
                  :items="phone.codes"
                  @change="cutPhone"
              ></v-select>
            </v-col>
            <v-col>
              <v-text-field-simplemask
                  v-model="phoneNumber"
                  :options="{
                inputMask: phone.getMask(phoneCode).input,
                outputMask: phone.getMask(phoneCode).output,
                empty: ''
              }"
                  :properties="{
                hint: 'На этот номер придет чек',
                'persistent-hint': true,
                placeholder: '',
                rules: rules.phone
              }"
              ></v-text-field-simplemask>
            </v-col>
            <v-col
                cols="12"
                sm="6"
            >
              <v-text-field
                  v-model.trim="email"
                  hint="На этот email также придет чек об оплате"
                  persistent-hint
                  prepend-icon="mdi-email-outline"
                  label="Введите email"
                  :rules="rules.email"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-form>
      </div>
    </div>
    <template slot="actions">
      <v-spacer></v-spacer>
      <v-btn
        color="primary"
        :disabled="paymentProcess"
        :loading="paymentProcess"
        @click="submit"
      >
        Оплатить
        <span v-if="!$vuetify.breakpoint.mobile">
          &nbsp;заказ по карте
        </span>
      </v-btn>
      <v-btn
        v-if="hasPaymentMethods"
        text
        :disabled="paymentProcess"
        @click="toPaymentConfirmation"
      >
        Или подтвердить
        <span v-if="!$vuetify.breakpoint.mobile">
          &nbsp;по старому
        </span>
      </v-btn>
    </template>
  </InterfaceCard>
</template>

<script>
import Info from '@/components/Info'
import InterfaceCard from '@/components/InterfaceCard'
import {setUrl} from "@/composables/frame"
import {getUserProfile} from '@/composables/user'
import {appStates, ccy, phone} from '@/constants'
import {
  invoiceGetAmountTitle, invoiceGetToBalanceTitle, invoiceInit, parsePhoneNumber, toBalanceCalc, toBalanceToggle
} from '@/services/utils'
import {windowOpen} from '@/services/vkApi'

let _sourceId
let _buyoutId
let _invoiceId

export default {
  name: 'Payment',
  components: {Info, InterfaceCard},
  computed: {
    canUseBalance () {
      return this.toBalance && this.toBalance.value < 0 && this.balanceCcy === this.ccy
    },
    hasPaymentMethods () {
      return this.buyoutItem && this.buyoutItem.acquiringPaymentType === 'acquiringAndPaymentMethods'
    },
    labelAmount () {
      return invoiceGetAmountTitle(
          this.ccy,
          this.toBalance && this.toBalance.active && this.toBalance.value,
          this.invoice,
          true
      )
    },
    labelToBalanceActivator () {
      return invoiceGetToBalanceTitle(this.balanceCcy, this.toBalance.value, true)
    },
    profile () {
      return getUserProfile()
    }
  },
  created () {
    _sourceId = this.$route.params.sourceId
    _buyoutId = this.$route.params.buyoutId
    _invoiceId = this.$route.params.invoiceId

    Promise.all([
      this.$client.get(this.$API.BALANCES.INFO, {params: {buyoutId: _buyoutId}}),
      this.$client.get(this.$API.BUYOUTS.ITEM, {params: {buyoutId: _buyoutId, describePaymentInfo: true}}),
      this.$client.get(this.$API.BUYOUTS.BUYOUT_ITEM, {params: {buyoutId: _buyoutId, invoices: true}}),
      this.$client.get(this.$API.BUYOUTS.BUYOUT_ITEM_INVOICE, {params: {id: _invoiceId}})
    ])
    .then(([balanceInfoRs, buyoutRs, buyoutItemRs, invoiceRs]) => {
      this.balance = balanceInfoRs.balance
      this.buyout = buyoutRs
      this.buyoutItem = buyoutItemRs
      this.ccy = ccy[this.buyout.buyoutCurrency].sign
      this.invoice = invoiceInit(invoiceRs)
      this.toBalance = toBalanceCalc(this.invoice, this.balance)
      this._fillPaymentFields()
    })
    .catch(err => this.error = err)
    .finally(() => this.loading = false)
  },
  data () {
    return {
      balanceCcy: ccy.RUB.sign,
      buyoutItem: null,
      ccy: null,
      email: '',
      error: null,
      formIsValid: false,
      rules: {
        email: [
          v => !!v || 'Введите email',
          v => !v || /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v.trim()) || 'Введите корректный email'
        ],
        phone: [
          v => !!v || 'Введите номер телефона',
          v => v && v.length === phone.getLength(this.phoneCode).validation || 'Введите корректный номер'
        ]
      },
      loading: true,
      paymentProcess: false,
      phone: phone,
      phoneCode: '',
      phoneNumber: '',
      toBalance: null
    }
  },
  methods: {
    changeToBalanceActive () {
      return toBalanceToggle(this.balance, this.invoice, this.toBalance)
    },
    cutPhone () {
      this.phoneNumber = this.phoneNumber.substring(0, phone.getLength(this.phoneCode).model)
    },
    submit () {
      if (!this.formIsValid) {
        this.$refs.paymentForm.validate()
        return
      }
      this.paymentProcess = true
      const url =
        `${this.$API.DOMAIN_ADDRESS}${this.buyoutItem.paymentUrl}&withBalance=${this.toBalance ? this.toBalance.active : false}&phone=${this.phoneCode}${this.phoneNumber}&email=${this.email}`
      if (this.buyoutItem.acquiringProvider === 'modulbank' || this.buyoutItem.acquiringProvider === 'yookassa') {
        windowOpen(url)
        this._toBuyouts()
      } else {
        this._openFrame(url)
          .then(() => this._toBuyouts())
          .finally(() => {
            this.paymentProcess = false
            setUrl()
          })
      }
    },
    toPaymentConfirmation () {
      this.$router.replace({
        name: appStates.buyoutPaymentConfirmation.name, params: {
          sourceId: this.buyout.sourceId, buyoutId: this.buyout.id, invoiceId: this.invoice.id
        }
      })
    },
    _fillPaymentFields () {
      let parsed = {}
      if (this.buyoutItem.phone) {
        parsed = parsePhoneNumber(this.buyoutItem.phone)
      }
      this.phoneCode = parsed.code || this.profile.phoneCode || phone.codes[0]
      this.phoneNumber = parsed.number || this.profile.phone
      this.email = this.buyoutItem.email
    },
    _openFrame (url) {
      setUrl(url)
      return new Promise((resolve, reject) => {
        window.addEventListener('message', e => {
          if (e.data.msg && e.data.msg.type === 'close') {
            if (e.data.msg.result === 'success') {
              resolve()
            } else {
              reject()
            }
          }
        }, false);
      })
    },
    _toBuyouts () {
      this.$router.push({name: appStates.sourceItemContent.name, params: {sourceId: _sourceId}})
    }
  }
}
</script>

<style scoped>
.phone-code {
  width: 102px;
}
</style>
